import request from '@/utils/request'; // 复用项目统一的 axios 实例

// 成果管理模块所有接口，统一导出（与仪器管理接口风格保持一致）
export default {
    // 1. 查询成果列表（分页+搜索）
    // params：支持 pageNum、pageSize、nameKeyword 等参数
    getList(params) {
        return request({
            url: '/institutions/',
            method: 'get',
            params // GET 请求参数拼在 URL 后（如 ?pageNum=1&pageSize=10&nameKeyword=xxx）
        });
    },
    //获取全部机构
    getAll() {
        return request({
            url: '/institutions',
            method: 'get',
        });
    },

    // 2. 新增成果数据（POST 请求，JSON 格式）
    create(institutionData) {
        return request({
            url: '/institutions/',
            method: 'post',
            data: institutionData, // 表单数据（含 projectName、category 等字段）
            headers: {
                'Content-Type': 'application/json' // 明确 JSON 格式（axios 可省略，保持与仪器管理一致）
            }
        });
    },

    // 3. 编辑成果数据（PUT 请求，JSON 格式）
    update(institutionData) {
        // 校验主键 ID（成果实体主键为 id，仪器是 instrumentNo，此处需区分）
        if (!institutionData.id) {
            console.error("编辑失败：成果 ID 不能为空");
            return Promise.reject(new Error("成果 ID 不能为空"));
        }
        return request({
            url: '/institutions/',
            method: 'put',
            data: institutionData // 表单数据（含 id 主键 + 其他修改字段）
        });
    },

    // 4. 删除成果数据（DELETE 请求，路径传参）
    delete(id) {
        // 校验主键 ID（成果用 id，仪器用 instrumentNo）
        if (!id) {
            console.error("删除失败：成果 ID 不能为空");
            return Promise.reject(new Error("成果 ID 不能为空"));
        }
        return request({
            url: `/institutions/${id}`, // 路径拼接 ID（与仪器管理的 instrumentNo 对应）
            method: 'delete'
        });
    },
    //5. 获取单个机构
    getColumnById(id) {
        if (!id) {
            console.error("成果 ID 不能为空");
            return Promise.reject(new Error("成果 ID 不能为空"));
        }
        return request({
            url: `/institutions/${id}`,
            method: 'get'
        })

    },
};